const inviteSignupBySuperAdmin = {
  toastr: 'Convite enviado',
  toastr1: 'O convite foi enviado com sucesso'
};

export default inviteSignupBySuperAdmin;
